"use client";
import React from "react";

import Header from "./../components/Header";
import Pricing from "./../components/Pricing";

const PricingPage = () => {
  return (
    <>
      <Header />
      <main data-router-wrapper>
        <section
          className="js-page page challenges abyss-simple-page"
          data-router-view="challenges"
        >
          <Pricing />
        </section>
      </main>
    </>
  );
};

export default PricingPage;
